import styled from 'styled-components';

// ⚠️ TEMPORÁRIO — botão flutuante só para testar a transição light/dark.
// Remover quando o toggle definitivo for posicionado (topbar, canto sup. direito).
export const FloatingButton = styled.button`
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 99999;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    border: 1px solid ${(props: any) => props.theme.colors.interfaceBorder100};
    background: ${(props: any) => props.theme.colors.primaryRed400};
    color: ${(props: any) => props.theme.colors.pureWhite};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
    transition: transform 0.15s ease, opacity 0.15s ease;

    &:hover {
        transform: scale(1.08);
    }

    &:active {
        transform: scale(0.96);
    }
`;

export const Badge = styled.span`
    position: fixed;
    right: 18px;
    bottom: 74px;
    z-index: 99999;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 2px 8px;
    border-radius: 8px;
    color: ${(props: any) => props.theme.colors.pureWhite};
    background: rgba(0, 0, 0, 0.55);
    pointer-events: none;
`;
